import colors from '../colors.js';
var r = colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");
export { r as default };
//# sourceMappingURL=Accent.js.map
